/**
 * Extracts the essay session ID from a writing coach URL.
 * @param url The URL to extract the essay session ID from
 * @returns The essay session ID if found, null otherwise
 * example:
 * https://khanacademy.org/writing-coach/essay/abc123/feedback -> abc123
 * https://khanacademy.org/writing-coach/abc123/feedback -> abc123
 */
export function getEssaySessionIdFromWritingCoachUrl(
    url: string,
): string | null {
    // Match /writing-coach/essay/{id}/ or /writing-coach/essay/{id}
    const siloUrlRegex = /\/writing-coach\/essay\/([^/]+)(?:\/|$)/;
    // Match /writing-coach/{id}/ or /writing-coach/{id} but not if it contains /essay/
    const oldUrlRegex = /\/writing-coach\/(?!essay\/)([^/]+)(?:\/|$)/;

    const siloUrlMatch = url.match(siloUrlRegex);
    if (siloUrlMatch?.[1]) {
        return siloUrlMatch[1];
    }

    const oldUrlMatch = url.match(oldUrlRegex);
    return oldUrlMatch?.[1] ?? null;
}
